import React, { FC } from 'react';
import { Author as AuthorData } from '../../../../shared/types';
import { getLinkAttributes } from '../helpers';

import './index.scss';

type AuthorProps = Partial<AuthorData> & { variant?: 'card' | 'sidebar' };

export const Author: FC<AuthorProps> = ({
  webLink,
  photo,
  heading,
  authorName,
  title,
  biography,
  variant = 'card',
}) => {
  const { image, alt } = photo || {};
  const linkAttrs = getLinkAttributes(webLink);
  const photoNode = image ? <img src={image} alt={alt} /> : null;
  const isSidebar = variant === 'sidebar';
  const titleNode =
    title &&
    (webLink ? (
      <a href={webLink} {...linkAttrs}>
        {title}
      </a>
    ) : (
      <span>{title}</span>
    ));

  return (
    <div className={variant === 'sidebar' ? 'sidebar-author' : 'about-author'}>
      <div className="title">
        {photoNode &&
          (webLink ? (
            <a href={webLink} {...linkAttrs}>
              {photoNode}
            </a>
          ) : (
            photoNode
          ))}
        <div>
          {heading && <h2 className="author-heading">{heading}</h2>}
          <h3 className="author-name">
            {authorName}
            {!isSidebar && titleNode}
          </h3>
        </div>
      </div>
      {isSidebar && titleNode && <div className="author-title">{titleNode}</div>}
      {biography && <p>{biography}</p>}
    </div>
  );
};
